<template>
  <div v-if="sAppInfo" class="container">
    <div class="mainPart applyForAccountCancellationStep">
      <span class="iconfont icon-warn1"></span>
      <span class="title">请用账户手机号接收验证码用于验证本人身份，再进行操作：</span>
      <div class="item phone">
        <span class="areaCode">+86</span>
        <div class="uni-input myInput">{{ formData.tel | formatPhone }}</div>
        <VerificationCode
          :verificationCodeInfo="verificationCodeInfo"
          class="verificationCode"
          @btnTapHandler="getTelCode()"
          @changeDisabledStatus="verificationCodeInfo.disabled = !verificationCodeInfo.disabled"
        >
        </VerificationCode>
      </div>
      <div class="item">
        <input class="uni-input myInput" v-model="formData.telCode" placeholder="请输入验证码" type="number" :adjust-position="false" maxlength="6" @blur="limitInput('code')" />
      </div>
    </div>
    <div class="optBox">
      <div class="btn alert tapActive" @click.stop="confirmBind">提交申请</div>
      <div class="btn normal tapActive" @click.stop="$router.go(-1)">取消申请</div>
    </div>
  </div>
</template>

<script>
import VerificationCode from '@/components/smartComponent/VerificationCode/index.vue'
import { mapGetters, mapActions } from 'vuex'
import { GetTelCode, CodeAvailable, ApplyFor } from '@/api/logoutApplyFor'
export default {
  name: 'applyForAccountCancellationStep2',
  data() {
    return {
      formData: {
        tel: undefined,
        telCode: undefined
      },
      codeNumber: '',
      verificationCodeInfo: {
        disabled: false
      }
    }
  },
  computed: {
    ...mapGetters(['sAppInfo'])
  },
  components: {
    VerificationCode
  },
  methods: {
    ...mapActions(['loginOut']),
    async CodeAvailableHandler() {
      try {
        await CodeAvailable(this.formData)
        const { Msg } = await ApplyFor(this.formData)
        this.$toast(Msg)
        this.$router.replace({
          name: 'inReview'
        })
      } catch (error) {
        this.$toast(error.ErrMsg)
        if (error.ErrMsg === '您的注销申请已审核通过，账号已注销，即将退出登录') {
          setTimeout(() => {
            this.loginOut().then(() => {
              this.$uni.postMessage({
                data: {
                  logOut: true
                }
              })
            })
          }, 1500)
        }
      }
    },
    confirmBind() {
      const { telCode } = this.formData
      let tempError
      if (!telCode.match(/^\d{6}$/)) {
        tempError = '验证码只能是6位数字'
      }
      if (tempError) {
        this.$toast(tempError)
        return
      }
      this.$dialog
        .alert({
          title: '提示',
          message: '提交申请后，管理员将尽快通过您的注销申请，审核通过将不再另行通知。是否确认提交注销申请？',
          showCancelButton: true
        })
        .then(() => {
          this.CodeAvailableHandler()
        })
        .catch(() => {
          // on cancel
        })
    },
    limitInput(val, type) {
      if (val === 'phone') {
        this.phoneNumber = this.phoneNumber.replace(/\D/g, '')
      } else {
        this.codeNumber = this.codeNumber.replace(/\D/g, '')
      }
    },
    async getTelCode() {
      const { tel: Tel } = this.formData
      let data = {
        Tel
      }
      try {
        const { Msg } = await GetTelCode(data)
        this.$toast(Msg)
      } catch (error) {
        this.$toast(error.ErrMsg)
      }
    }
  },
  watch: {
    phoneNumber(val) {
      if (!/^1[3456789][0-9]{9}$/g.test(val)) {
        this.verificationCodeInfo.disabled = true
      } else {
        this.verificationCodeInfo.disabled = false
      }
    }
  },
  mounted() {
    if (!this.sAppInfo) {
      this.$router.push('my')
    } else {
      this.formData.tel = this.sAppInfo.LoginName
    }
  }
}
</script>

<style lang="scss" scoped>
@import './css/applyForAccountCancellationStep';
.container {
  padding-top: vw(20);
  justify-content: flex-start;

  .mainPart {
    margin-bottom: vw(57);
    .title {
      margin-bottom: vw(50);
    }
    .item {
      display: flex;
      align-items: center;
      height: vw(60);
      // width: 100%;
      width: vw(280);
      border-bottom: 1px solid #f2f2f2;
      &.phone {
        color: #9c9c9c;
      }
      .areaCode {
        margin-right: vw(13);
        font-size: vw(14);
      }
      .myInput {
        font-size: vw(14);
        line-height: vw(14);
        flex: 1;
      }

      .verificationCode {
        height: vw(60);
        line-height: vw(60);
      }
    }
  }
}
</style>
